import { BasePostRequest } from './core/basePostRequest';
import { ApiResponse, Success } from '../responses';
import * as t from 'io-ts';
import { Authentication } from './core/baseRequest';

export class PasswordResetLinkRequest extends BasePostRequest<undefined> {
    constructor(public email: string) {
        super('users/request-password-reset', {}, {email}, t.undefined, Authentication.None);
    }
}
